// GFF Wideo promo - odtwarzanie (YouTube lub plik mp4)
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var players = document.querySelectorAll('.gff-video__player');

    players.forEach(function (player) {
      var button = player.querySelector('.gff-video__play');

      if (!button) {
        return;
      }

      button.addEventListener('click', function () {
        player.classList.add('gff-video__player--playing');

        var youtubeId = button.getAttribute('data-youtube-id');
        if (youtubeId) {
          // podmiana postera na osadzony player YouTube (z autoplayem)
          var iframe = document.createElement('iframe');
          iframe.className = 'gff-video__media gff-video__iframe';
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?autoplay=1&rel=0';
          iframe.title = 'Film z poprzedniej edycji Forum';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          player.innerHTML = '';
          player.appendChild(iframe);
          return;
        }

        var video = player.querySelector('video.gff-video__media');
        if (video) {
          video.setAttribute('controls', '');
          video.play();
        }
      });
    });
  });
})();
